"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DingdingFilled = void 0;
/* eslint-disable max-len */
var react_1 = __importDefault(require("react"));
var icon_1 = require("../utils/icon");
exports.DingdingFilled = (0, icon_1.makeIcon)({
    Path: function (_a) {
        var colors = _a.colors;
        return react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("path", { d: "M55.892 24.275C55.7851 24.7198 55.5232 25.3699 55.1662 26.1683L55.1304 26.2482C53.0006 30.8447 47.4435 39.8439 47.4435 39.8439L47.4198 39.7868L45.7896 42.6383H53.6192L38.6499 62.6668L42.0414 49.037H35.8774L38.0192 40.0148C36.2939 40.437 34.2352 41.0186 31.8078 41.7943C31.8078 41.7943 28.5235 43.7332 22.3598 38.0644C22.3598 38.0644 18.195 34.369 20.5987 33.4452C21.622 33.046 25.5845 32.5442 28.7022 32.1335C32.9144 31.5634 35.4966 31.2554 35.4966 31.2554C35.4966 31.2554 22.5264 31.4607 19.4444 30.97C16.3625 30.4796 12.4595 25.3243 11.6385 20.762C11.6385 20.762 10.3533 18.2641 14.411 19.4503C18.4568 20.6251 35.235 24.0582 35.235 24.0582C35.235 24.0582 13.3996 17.3174 11.9478 15.675C10.4842 14.044 7.66406 6.71006 8.03294 2.20478C8.03294 2.20478 8.18763 1.08701 9.32998 1.38356C9.32998 1.38356 25.4536 8.80872 36.4963 12.8578C47.5387 16.941 57.1296 19.0055 55.892 24.275Z", fill: colors[0] }));
    },
    name: 'dingding_filled',
    defaultColors: ['#D9D9D9'],
    colorful: false,
    allPathData: ['M55.892 24.275C55.7851 24.7198 55.5232 25.3699 55.1662 26.1683L55.1304 26.2482C53.0006 30.8447 47.4435 39.8439 47.4435 39.8439L47.4198 39.7868L45.7896 42.6383H53.6192L38.6499 62.6668L42.0414 49.037H35.8774L38.0192 40.0148C36.2939 40.437 34.2352 41.0186 31.8078 41.7943C31.8078 41.7943 28.5235 43.7332 22.3598 38.0644C22.3598 38.0644 18.195 34.369 20.5987 33.4452C21.622 33.046 25.5845 32.5442 28.7022 32.1335C32.9144 31.5634 35.4966 31.2554 35.4966 31.2554C35.4966 31.2554 22.5264 31.4607 19.4444 30.97C16.3625 30.4796 12.4595 25.3243 11.6385 20.762C11.6385 20.762 10.3533 18.2641 14.411 19.4503C18.4568 20.6251 35.235 24.0582 35.235 24.0582C35.235 24.0582 13.3996 17.3174 11.9478 15.675C10.4842 14.044 7.66406 6.71006 8.03294 2.20478C8.03294 2.20478 8.18763 1.08701 9.32998 1.38356C9.32998 1.38356 25.4536 8.80872 36.4963 12.8578C47.5387 16.941 57.1296 19.0055 55.892 24.275Z'],
    width: '64',
    height: '64',
    viewBox: '0 0 64 64',
});
